import React from 'react';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';

export default function SprintCta({ 
    title, 
    subtitle, 
    subtitle2, 
    buttonText, 
    extraClasses = '' 
}) {
    const arrowSVG = (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ verticalAlign: 'middle', marginLeft: '8px' }}>
            <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );

    return (
        <section className={`sprint-cta ${extraClasses}`}>
            <Container>
                <div className="sprint-reveal">
                    <h2>{title}</h2>
                    <p className="cta-sub">{subtitle}</p>
                    {subtitle2 && <p className="cta-sub-2">{subtitle2}</p>}
                    <Link to="/book-audit" className="sprint-btn-primary">
                        {buttonText} {arrowSVG}
                    </Link>
                </div>
            </Container>
        </section>
    );
}
